module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av491-5b8281f8f27bad6368056df9c440d0fc.jpg";